import { mergeDeepRight, prop, propEq, sum } from 'ramda'
import React from 'react'

import { Column } from '@ant-design/plots'

import { useColors } from '../../../kiti/components/theme/_hooks/colors'

const ColumnChart = ({ data, xField, yField, seriesField, ...props }) => {
  const colors = useColors()

  const config = mergeDeepRight(
    {
      data,
      xField,
      yField,
      seriesField,
      isGroup: true,
      animation: false,
      columnStyle: {
        radius: [5, 5, 0, 0]
      },
      legend: {
        position: 'top-right',
        itemValue: {
          formatter: (type, item) => {
            const total = sum(data.filter(propEq(seriesField, type)).map(prop(yField)))
            return `:  ${total}`
          }
        }
      },
      point: {
        size: 3,
        shape: 'circle'
      }
    },
    props
  )

  return <Column {...config} />
}

export default ColumnChart
